import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {RequestBoxComponent} from './requestBox.component';
const routes: Routes = [
  {
    path: '',
    component: RequestBoxComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RequestBoxRoutingModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/requestBox/requestBox-routing.module.ts